import { render, staticRenderFns } from "./CommunityPostsCard6.vue?vue&type=template&id=69a28fed&"
import script from "./CommunityPostsCard6.vue?vue&type=script&lang=js&"
export * from "./CommunityPostsCard6.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports